import React from 'react';
import clsx from 'clsx';

import './horizontal-menu.scss';

const HorizontalMenu = ({ items, className }) => {
  return (
    <div className={clsx('horizontal-menu', className)}>
      {items.map((item) => {
        return (
          <div
            key={item.id}
            className={clsx(
              'horizontal-menu__item',
              item.active && 'horizontal-menu__item--active',
              { 'horizontal-menu__item--show': item?.show !== false },
            )}
          >
            <button
              className={clsx('horizontal-menu__button', 'button--unstyled')}
              onClick={item.onClick}
            >
              {item.name}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalMenu;
